export const DETAILS_SVA_STAGES = {
  INITIAL: 'initial',
  INTEGRATION_ERROR: 'integration_error',
}
